import { Body, Box } from "@biom3/react";
import Image from "next/image";

export function ImxFoundation() {
  return (
    <Box>
      <Box
        sx={{
          mt: "base.spacing.x6",
        }}
      >
        <Body
          size="small"
          sx={{
            color: "base.color.text.body.secondary",
          }}
        >
          In partnership with
        </Body>
      </Box>
      <Image
        src="/images/rewards/imx-ecosystem-foundation.svg"
        alt="IMX Ecosystem Foundation"
        width={150}
        height={75}
      />
    </Box>
  );
}
